window.dataLayer = window.dataLayer || [];
function gtagConcentMode(){dataLayer.push(arguments);}
// Function to set a cookie
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Function to check if user is from California
async function isQuebecVisitor() {
  try {
    // Check if we already have the geolocation data in sessionStorage
    const cachedGeoLocation = sessionStorage.getItem('geo_location');
    if (cachedGeoLocation) {
      const geoData = JSON.parse(cachedGeoLocation);
      return geoData.country === 'CA' && geoData.region === 'QC';
    }

    // Fetch geolocation data from API
    const response = await fetch('https://dq0jpe8685dh3.cloudfront.net/geo-consent');
    if (!response.ok) {
      return false; // Graceful degradation on API failure
    }

    const geoData = await response.json();
    // Cache the result in sessionStorage
    sessionStorage.setItem('geo_location', JSON.stringify(geoData));
    
    return geoData.country === 'US' && geoData.region === 'CA';
  } catch (error) {
    console.error('Error checking geolocation:', error);
    return false; // Return false on error to prevent blocking consent flow
  }
}

async function consentDefault() {
  let marketingAllowed = getCookie('marketingAllowed') == 'true' ? true : 'x';
  let analyticsProcessingAllowed = getCookie('analyticsProcessingAllowed') == 'true' ? true : 'x';
  let preferencesProcessingAllowed = getCookie('preferencesProcessingAllowed') == 'true' ? true : 'x';
  const isFromCalifornia = await isQuebecVisitor();
  
  if(getCookie('marketingAllowed') === null){
    console.log('dont found cookies set all on default');

    const defaultConsent = (isFromCalifornia ? false : true) ? 'true' : 'false';
    marketingAllowed = defaultConsent;
    analyticsProcessingAllowed = defaultConsent
    preferencesProcessingAllowed = defaultConsent;
        setCookie('marketingAllowed', marketingAllowed, 180);
        setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, 180);
        setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, 180);
  }
  gtagConcentMode('consent', 'default', {
    'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
    'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
    'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
    'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
  });
  dataLayer.push({event:'concent_initializing'});
  
}
consentDefault();
document.addEventListener('readystatechange', function (event) {
  if (event.target.readyState === "complete") {
    initCookies();
  }
});
async function initCookies () {
  const consentFooter = document.getElementById('custom-consent-footer');
  const overlay = document.getElementById('custom-consent-overlay');
  const consentPopup = document.getElementById('custom-consent-popup');
  const openConsentButton = document.getElementById('openConsentPopup');
  const openConsentButtonFooter = document.getElementById('cookie-consent-button');
  const saveConsentButton = document.getElementById('saveConsent');
  const saveAcceptConsentAll = document.querySelectorAll('.cookies-concent-save-all');
  const declineConsentAll = document.querySelectorAll('.cookies-concent-decline-all');
  const btnDeclineAll = document.querySelector('button.cookies-concent-decline-all');
  const closePopupButton = document.getElementById('closeConsentPopup');
  const closeFooterButton = document.getElementById('closeFooterPopup');
  const cookieSettingsAnchors = document.querySelectorAll('a[href="#cookie-settings"]');
  const showMoreButton = document.querySelector('#custom-consent-footer button.show-more');
  const bannerMessage = document.querySelector('#custom-consent-footer p.collapse');
  const announcementBar = document.querySelector('.announcement-bar__content.announcement-bar__content--center');
  const bannerAcceptButton = document.getElementById('accept-all-cookies');
  const footerParagraph = document.querySelector('#custom-consent-footer p.collapse');
  const privacyPolicyLink = footerParagraph.querySelector('a');

  // Check if visitor is from California and hasn't set preferences
  const isFromCalifornia = await isQuebecVisitor();
  const hasSetPreferences = localStorage.getItem('privacy-concent') === 'true';

  // Auto-display popup for California visitors who haven't set preferences
  if (isFromCalifornia && !hasSetPreferences) {
    consentPopup.style.display = 'block';
    overlay.style.display = 'block';

    // Set focus to close button for accessibility
    setTimeout(() => {
      if (closePopupButton) {
        closePopupButton.focus();
      }
    }, 50);
  }

  // console.log(window.Shopify)
  // console.log(window.Shopify.loadFeatures)
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        console.log('we can no use consent settings from shopify');
      } else {
        if(!isFromCalifornia) {
          let marketingAllowed = window.Shopify.customerPrivacy.marketingAllowed() == true ? true : 'x';
          let analyticsProcessingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed() == true ? true : 'x';
          let preferencesProcessingAllowed = window.Shopify.customerPrivacy.preferencesProcessingAllowed() == true ? true : 'x';
          document.getElementById("marketingAllowed").checked = marketingAllowed == true ? true : false;
          document.getElementById("analyticsAllowed").checked = analyticsProcessingAllowed == true ? true : false;
          document.getElementById("preferencesAllowed").checked = preferencesProcessingAllowed == true ? true : false;
          setCookie('marketingAllowed', marketingAllowed, 180);
          setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, 180);
          setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, 180);
          console.log('calling gtagConcentMode on load');
          gtagConcentMode('consent', 'update', {  
            'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
            'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
            'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
            'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
          });
          dataLayer.push({event:'concent_updating'});
          if(localStorage.getItem("privacy-concent") === null || localStorage.getItem("privacy-concent") === "false"){
            consentFooter.style.display = 'flex';
          }
        }
      }
    },
  );

  if (openConsentButton && consentPopup) {

    openConsentButton.addEventListener('click', function() {
      consentPopup.style.display = 'block';
      overlay.style.display = 'block';
      closePopupButton.focus();
    });

    openConsentButtonFooter.addEventListener('click', function() {
      consentPopup.style.display = 'block';
      overlay.style.display = 'block';
      closePopupButton.focus();
    });

    cookieSettingsAnchors.forEach(function(el){
      el.addEventListener('click', function(e) {
        e.preventDefault();
        consentPopup.style.display = 'block';
        overlay.style.display = 'block';
      });
    })

  }

  if (saveConsentButton) {
    closeFooterButton.addEventListener('click', function(){
      consentFooter.style.display = 'none';
      localStorage.setItem("privacy-concent", "true");
      announcementBar.focus();
    })

        closeFooterButton.addEventListener('keydown', function(e){
      if(e.key === 'Tab' && !e.shiftKey){
        e.preventDefault();
        if (privacyPolicyLink && footerParagraph.classList.contains('show')) {
          privacyPolicyLink.focus();
        } else {
          showMoreButton.focus();
        }
      } else if(e.key === 'Tab' && e.shiftKey){
        e.preventDefault();
        bannerAcceptButton.focus();
      }
    });
    showMoreButton.addEventListener('keydown', function(e){
      if(e.key === 'Tab' && e.shiftKey){
        e.preventDefault();
        if (privacyPolicyLink && footerParagraph.classList.contains('show')) {
          privacyPolicyLink.focus();
        } else {
          closeFooterButton.focus();
        }
      }
    });

    closePopupButton.addEventListener('click', function(){
      // For California users, closing the popup acts as "Decline All"
      if (isFromCalifornia) {
        document.getElementById('marketingAllowed').checked = false;
        document.getElementById('analyticsAllowed').checked = false;
        document.getElementById('preferencesAllowed').checked = false;
        savePreferences();
      } else {
        // For non-California users, just close the popup
        consentPopup.style.display = 'none';
        overlay.style.display = 'none';
        openConsentButton.focus();
      }
    });

        closePopupButton.addEventListener('keydown', function(e){
      if(e.key === 'Tab' && e.shiftKey){
        e.preventDefault();
        btnDeclineAll.focus();
      }
    });
    btnDeclineAll.addEventListener('keydown', function(e){
      if(e.key === 'Tab' && !e.shiftKey){
        e.preventDefault();
        closePopupButton.focus();
      }
    });
    bannerAcceptButton.addEventListener('keydown', function(e){
      if(e.key === 'Tab' && !e.shiftKey){
        e.preventDefault();
        closeFooterButton.focus();
      }
    });

    saveConsentButton.addEventListener('click', function() {
      savePreferences();
    });
    saveAcceptConsentAll.forEach(function(el){
      el.addEventListener('click', function() {
        document.getElementById('marketingAllowed').checked = true;
        document.getElementById('analyticsAllowed').checked = true;
        document.getElementById('preferencesAllowed').checked = true;
        savePreferences();
      });
    });
    declineConsentAll.forEach(function(el){
      el.addEventListener('click', function() {
        document.getElementById('marketingAllowed').checked = false;
        document.getElementById('analyticsAllowed').checked = false;
        document.getElementById('preferencesAllowed').checked = false;
        savePreferences();
      });
    });
    showMoreButton.addEventListener('click', function() {
      const showMoreContent = document.querySelector('#custom-consent-footer p');
      showMoreContent.classList.toggle('show');
      bannerMessage.focus();
    });
  }
}
function savePreferences () {
  const consentPopup = document.getElementById('custom-consent-popup');
  const overlay = document.getElementById('custom-consent-overlay');
  const consentFooter = document.getElementById('custom-consent-footer');

  const marketingAllowed =  document.getElementById('marketingAllowed').checked  == true ? true :  'x';
  const analyticsProcessingAllowed =  document.getElementById('analyticsAllowed').checked  == true ? true :  'x';
  const preferencesProcessingAllowed =  document.getElementById('preferencesAllowed').checked  == true ? true :  'x';

  setCookie('marketingAllowed', marketingAllowed, 180);
  setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, 180);
  setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, 180);
  gtagConcentMode('consent', 'update', {  
    'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
    'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
    'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
    'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
  });
  dataLayer.push({event:'concent_updating'});
  const consentOptions = {
    marketing: marketingAllowed == true ? true : false,
    analytics: analyticsProcessingAllowed == true ? true : false,
    preferences: preferencesProcessingAllowed == true ? true : false
  };
  window.Shopify.customerPrivacy.setTrackingConsent(
    consentOptions,
    () => {
      consentPopup.style.display = 'none';
      overlay.style.display = 'none';
      consentFooter.style.display = 'none';
      localStorage.setItem("privacy-concent", "true");
    }
  );
}